export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; licence: true }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'home',
        licence: true,
      },
    },
    {
      name: 'business-finances',
      displayName: 'Finanzas',
      meta: {
        icon: 'account_balance_wallet',
      },
      children: [
        {
          name: 'egresos',
          displayName: 'Egresos',
          meta: { icon: 'trending_down' },
        },
        {
          name: 'ingresos',
          displayName: 'Ingresos',
          meta: { icon: 'trending_up' },
        },
      ],
    },
    {
      name: 'facturacion',
      displayName: 'Facturacion',
      meta: {
        icon: 'request_quote',
        licence: false,
      },
      children: [
        {
          name: 'generar-factura',
          displayName: 'Nueva Factura',
          meta: { icon: 'request_quote', licence: false },
        },
        {
          name: 'ventas',
          displayName: 'Facturas Emitidas',
          meta: { icon: 'request_quote' },
        },
        {
          name: 'compras',
          displayName: 'Facturas Recibidas',
          meta: { icon: 'receipt_long' },
        },
      ],
    },
    {
      name: 'budgets',
      displayName: 'menu.budgets',
      meta: { icon: 'savings' },
    },
    {
      name: 'funds',
      displayName: 'Fondos',
      meta: { icon: 'account_balance_wallet' },
    },
    {
      name: 'accounts',
      displayName: 'Cuentas',
      meta: { icon: 'account_balance' },
    },
    {
      name: 'administracion',
      displayName: 'menu.myBusiness',
      meta: {
        icon: 'admin_panel_settings',
      },
      children: [
        {
          name: 'users',
          displayName: 'Clientes',
          meta: { icon: 'group' },
        },
        {
          name: 'products',
          displayName: 'Productos',
          meta: { icon: 'inventory' },
        },
      ],
    },
    {
      name: 'categories',
      displayName: 'Categorias',
      meta: { icon: 'category' },
      children: [
        {
          name: 'categories-egresos',
          displayName: 'Egresos',
          meta: { icon: 'trending_down' },
        },
        {
          name: 'categories-ingresos',
          displayName: 'Ingresos',
          meta: { icon: 'trending_up' },
        },
      ],
    },
    {
      name: 'reminders',
      displayName: 'Recordatorios',
      meta: { icon: 'notifications' },
    },
    {
      name: 'reports',
      displayName: 'menu.reports',
      meta: {
        icon: 'insert_chart',
      },
    },
    {
      name: 'tax',
      displayName: 'menu.taxServices',
      meta: {
        icon: 'receipt_long',
      },
    },
    {
      name: 'settings',
      displayName: 'Configuración',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'preferences',
      displayName: 'Mi Perfil',
      meta: {
        icon: 'person',
      },
    },
  ] as INavigationRoute[],
}
